import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_ENDPOINTS } from '@shared/constants';
import { Observable, take } from 'rxjs';
import { BaseResponse } from '@core/interfaces';
import { AssignedDriver } from '@features/live-map/interfaces/assignDrivers.interface';
import { LinkedCustomerVehicle } from '@features/live-map/interfaces/linkedCustomerVehicle.interface';

@Injectable()
export class LiveMapService {
  readonly http = inject(HttpClient);

  public getRoutNumbersList(locationId: number[]): any {
    return this.http
      .post(API_ENDPOINTS.LiveMap.GetRoutes, {
        locationsIds: locationId,
      })
      .pipe(take(1));
  }

  public getAssignedDrivers(
    customerIds: number[] | undefined
  ): Observable<AssignedDriver> {
    return this.http
      .post<AssignedDriver>(
        `${API_ENDPOINTS.LiveMap.GetAssignedDrivers}`,
        customerIds
      )
      .pipe(take(1));
  }

  public getCustomersVehicleLinks(
    customerIds: number[]
  ): Observable<BaseResponse<LinkedCustomerVehicle[]>> {
    return this.http
      .post<BaseResponse<LinkedCustomerVehicle[]>>(
        `${API_ENDPOINTS.Vehicles.getCustomersVehicleLinks}`,
        customerIds
      )
      .pipe(take(1));
  }
}
